/* 
/* ロード完了時のアニメーション
*/
$(window).on('load', function () {
    $('#loading').addClass('loaded');
});

// ブラウザバック時にonloadが発火しない問題
window.addEventListener('pageshow', function () {
    $('#loading').addClass('loaded');
});


/* 
/* 画面遷移前のアニメーション
*/
$('a').on('click', function (event) {
    var link = $(this).attr('href');
    var target = $(this).attr('target');
    var isTelLink = link.startsWith('tel:');
    var isPageAnchorLink = link.startsWith('#');

    if (target === '_blank' || isTelLink || isPageAnchorLink) {
        return;
    }

    event.preventDefault();
    $('#loading').removeClass('loaded');
    setTimeout(function () {
        location.href = link;
    }, 250);
});


/* 
/* ハンバーガーメニューの処理
*/
$(".openbtn").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".bg-black").toggleClass('active');
});

$(".bg-black").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".openbtn").toggleClass('active');
});


/* 
/* スマホメニューの高さ計算
*/

const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight);
// 初期化
setFillHeight();


/* 
/* ヘッダー切り替え
*/

/*
$(document).ready(function () {
    $(window).on("scroll load", function () {
        var fvWrapHeight = $(".fv__wrap").outerHeight();

        if ($(window).scrollTop() > fvWrapHeight - 77) {
            $(".add-header").addClass("active");
        } else {
            $(".add-header").removeClass("active");
        }
    });
});
*/


/* 
/* GSAP fadein処理
*/

const fadeinElements = document.querySelectorAll('.fadein');

fadeinElements.forEach(element => {
    // 各要素ごとにアニメーションを設定
    gsap.fromTo(element, {
        autoAlpha: 0,
        y: 20
    }, {
        autoAlpha: 1,
        duration: 1,
        y: 0,
        scrollTrigger: {
            trigger: element, // 各要素をトリガーとする
            start: 'top 70%',
            //markers: true,
        }
    });
});